import React from 'react'
import { FaHeartCircleCheck } from 'react-icons/fa6'
import { PiPlanet } from 'react-icons/pi'
import { RiExternalLinkFill } from 'react-icons/ri'
import HeaderPage from '../../components/headerpage/HeaderPage'
import useAppContext from '../../hook/useAppContext'
import Empty from '../../components/empty/Empty'
import './relation.css'

const Relation = ({current}) => {

      const {user, break_line} = useAppContext()
      const {relation} = user 

      if(current !== 'relationship') return 

      if(relation.code){
            return (
                  <Empty title={"Relationship"} desc={"The user is currently not in any relationship."}/>
            )
      }

      const name = relation.name 
      const dicebaer = `https://api.dicebear.com/5.x/initials/svg?seed=${name}&fontSize=28`
      const avatar = relation.avatar.length === 0 ? dicebaer : relation.avatar 
      const id_xat = relation.id_xat 
      const type = relation.relation_type 
      const time_lapse = relation.love_count === 'undefined' ? "" : relation.love_count.time_lapse 
      const about = relation.about.length === 0 ? "" : relation.about 
      const me = relation.me
      const homepage = relation.homepage.length === 0 ? relation.me : relation.homepage 

      return (
            <div className="page_group">
                  <HeaderPage desc={`Relationship`} />
                  <div className="wrapper_relation">
                        <div className="relation_group">
                              <div className="relation_banner__group">
                                    <div className="relation_banner__img flex">
                                          <img src={avatar} alt={name} />
                                    </div>
                                    <div className="relation_banner__data flex">
                                          <h2>{name}</h2>
                                          <strong>{id_xat}</strong>
                                          <p>holaxat.com</p>
                                    </div>
                                    <div className="relation_banner__icon flex">
                                          <FaHeartCircleCheck />
                                    </div>
                              </div>
                              <div className="relation_content">
                                    <div className="relation_content__header">
                                          <h3>{type}</h3>
                                          <p>{time_lapse}</p>
                                    </div>
                                    <div className="relation_content__description">
                                          <p>{break_line(about)}</p>
                                    </div>
                                    <div className="relation_content__action flex">
                                          <a href={me} className="btn_relation flex" target="_blank" rel="noreferrer">
                                                <div className="btn_relation__icon">
                                                      <PiPlanet />
                                                </div>
                                                <span>xatMe</span>
                                          </a>
                                          <a href={homepage} className="btn_relation flex" target="_blank" rel="noreferrer">
                                                <div className="btn_relation__icon">
                                                      <RiExternalLinkFill />
                                                </div>
                                                <span>WebSite</span>
                                          </a>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      )
}

export default Relation
